require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-pav-bhaji.json") })
        }
      }, "path---recipes-pav-bhaji");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-pav-bhaji!./.cache/json/recipes-pav-bhaji.json
// module id = 735
// module chunks = 231608221292675